import instructorSelectors from "modules/instructor/duck/selectors"
import usersSelectors from "modules/users/duck/selectors"

export default {
  instructor: instructorSelectors,
  users: usersSelectors,
}
